import React from "react";
import { AppBar, Toolbar } from "@mui/material";
import { Box } from "../../../design-system";
import { colors } from "../../../design-system/colors";
import { useScrollEffect } from "./hooks/useScrollEffect";
import Logo from "./Logo";
import NavLinks from "./NavLinks";
import AuthButtons from "./AuthButtons";
import "./NavigationBar.css";

interface NavigationBarProps {
  onSignUpClick: () => void;
  onLogInClick: () => void;
}

const NavigationBar: React.FC<NavigationBarProps> = ({
  onSignUpClick,
  onLogInClick,
}) => {
  const isScrolled = useScrollEffect();

  return (
    <AppBar
      position="sticky"
      color="transparent"
      className={`navigation-bar ${isScrolled ? "scrolled" : ""}`}
      sx={{
        backgroundColor: isScrolled
          ? "rgba(29, 33, 45, 0.8)"
          : colors.background[850],
        backdropFilter: isScrolled ? "blur(10px)" : "none",
        boxShadow: "none",
        transition: "all 0.3s ease",
        padding: { xs: "16px 0", md: "24px 0" },
        minHeight: { xs: "64px", md: "72px" },
        mb: { xs: "16px", md: "24px" },
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          margin: "0 auto",
          padding: { xs: "0 16px", md: "0 24px" },
          minHeight: { xs: "64px", md: "auto" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: { xs: "1rem", md: "2rem" },
            flex: 1,
          }}
        >
          <Logo />
          <NavLinks />
        </Box>
        <AuthButtons
          onSignUpClick={onSignUpClick}
          onLogInClick={onLogInClick}
        />
      </Toolbar>
    </AppBar>
  );
};

export default NavigationBar;
